var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav', {
    ref: "navComp"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "shopWarp"
  }, [_c('div', {
    staticClass: "shopBox"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "alt": "暂无图片"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "shopBox-right"
    }, [_c('p', {
      staticClass: "rightTitle"
    }, [_vm._v(_vm._s(goodsBo.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "rightdetail"
    }), _vm._v(" "), _c('div', {
      staticClass: "priceleft ov_hid"
    }, [_c('a', {
      staticClass: "priceright right",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n\t\t                                \t马上兑\n\t\t                            ")]), _vm._v(" "), (goodsBo.unitPrice > 0) ? _c('span', {
      staticClass: "currentPrice"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]) : _vm._e()]), _vm._v(" "), (goodsBo.goodsPrice > 0) ? _c('div', {
      staticClass: "duihuan"
    }, [_vm._v("兑换积分："), _c('span', [_vm._v(_vm._s((goodsBo.goodsPrice)))])]) : _vm._e(), _vm._v(" "), (goodsBo.discountMoney > 0) ? _c('div', {
      staticClass: "duihuan"
    }, [_vm._v("可抵扣："), _c('span', [_vm._v("￥" + _vm._s((goodsBo.discountMoney / 100).toFixed(2)))])]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('ul', [_c('p', {
    staticClass: "n1"
  }, [_vm._v("1.积分获取方式："), _c('br'), _vm._v("\n\t\t\t        ▲在云商城消费奖励积分商品"), _c('br'), _vm._v("\n\t\t\t        ▲在商城积分活动中获得积分")]), _vm._v(" "), _c('p', {
    staticClass: "n2"
  }, [_vm._v("2.积分使用方法："), _c('br'), _vm._v("\n\t\t\t        ▲积分可以代替现金购买商城内的积分商品"), _c('br'), _vm._v("\n\t\t\t        ▲积分可以换取云商城专属的礼品")]), _vm._v(" "), _c('p', {
    staticClass: "n3"
  }, [_vm._v("云商城 秋冬货品持续更新中...")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe69e46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/points/points_area.vue
// module id = /C53
// module chunks = 1